import script from "./SlotFiltersByDays.vue?vue&type=script&setup=true&lang=js"
export * from "./SlotFiltersByDays.vue?vue&type=script&setup=true&lang=js"

import "./SlotFiltersByDays.vue?vue&type=style&index=0&id=5d8beb3e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d8beb3e"]])

export default __exports__